import { AccountConstants } from 'modules/layout/store/constants';
import { RequestAction } from '@redux-requests/core';
import { AppsConstants } from 'modules/userApps/store/constants';
import { gql } from '@redux-requests/graphql';
import { transformRolesResponse } from 'modules/userApps/store/responseTransforms';

export interface IAddNewScopes {
  id: string;
  roles: any;
}

export const addNewScopes = ({ id, roles }: IAddNewScopes): RequestAction => ({
  type: AccountConstants.ADD_NEW_SCOPES,
  request: {
    query: gql`
      mutation($id: ID, $roles: [AppRolePayload]) {
        saveApp(app: { id: $id, roles: $roles }) {
          id
          roles {
            name
            types
          }
        }
      }
    `,
    variables: {
      id,
      roles: roles.map(({ name, types }: { name: string; types: string[] }) => ({ name, types })),
    },
  },
  meta: {
    requestKey: id,
    mutations: {
      [AppsConstants.APP + id]: (data, { saveApp }) => {
        const { roles } = saveApp;
        return { ...data, ...saveApp, roles: transformRolesResponse(roles) };
      },
    },
  },
});
